module.exports = __webpack_public_path__ + "static/media/pic2.9d05a6ef.jpg";